import React from 'react';
import { JobStageTemplateInput } from '../../../../../../../PlanTemplates/SetupPlanTemplatePage';
import styles from '../styles.module.scss';
import classNames from 'classnames';
import { InterviewKitPanel } from '../../../../../../../../components/ApplicantTracking/InterviewKitPanel';
import { ScorecardTemplateTable } from '../../../../../../../../components/ApplicantTracking/ScorecardTemplateTable';
import { DeprecatedPanel } from '../../../../../../../../components/DeprecatedPanel';
import { ScorecardTemplate } from '../../../../../../../../entities/v1/applicant_tracking/ScorecardTemplate';

interface PropTypes {
  jobStage: JobStageTemplateInput;
  scorecardTemplates: ScorecardTemplate[];
}

export function JobStageDetail(props: PropTypes) {
  const selectedScorecardTemplate = props.scorecardTemplates.find(
    (scorecardTemplate) =>
      scorecardTemplate.id === props.jobStage.scorecardTemplate?.id,
  );

  return (
    <DeprecatedPanel
      additionalInnerContainerClassNames={classNames(
        styles['job-stage-container'],
      )}
    >
      <div className='fs-2 fw-bold mb-4'>{props.jobStage.name}</div>
      <div className='my-1 fs-3 fw-semibold'>Interview Questions</div>
      <div className='fs-5 mt-3 fw-semibold'>
        {props.jobStage.interviewKitTemplate.name}
      </div>
      <InterviewKitPanel
        sections={props.jobStage.interviewKitTemplate.sections}
      />
      <div className='mt-4 mb-3 fs-3 fw-semibold'>Interview Scorecard</div>
      <div className='my-1 mb-3 fs-5 fw-semibold'>
        {selectedScorecardTemplate.surveyTemplate.name}
      </div>
      <div className='mb-3 pb-1'>
        <ScorecardTemplateTable scorecardTemplate={selectedScorecardTemplate} />
      </div>
    </DeprecatedPanel>
  );
}
